module.exports = __webpack_public_path__ + "img/airplane-6.6d315dc4.jpg";